<ng-container *ngIf="report$ | async as report">
  <app-cp-reports-month-selector></app-cp-reports-month-selector>

  <ng-container>
    <app-cp-reports-hours-saved></app-cp-reports-hours-saved>

    <app-cp-report-months></app-cp-report-months>
    
    <app-cp-reports-scale-selector></app-cp-reports-scale-selector>
  </ng-container>
       
</ng-container>

